import * as React from "react"
import { useTimeTableColor } from '../../state/storeTimeTableColor';

function ShowHideHightLight() {
	const updateShowHightLight = useTimeTableColor(
		( state ) => state.updateShowHightLight
	);

	const ShowHightLight = useTimeTableColor(
		( state ) => state.ShowHightLight
	);
	return (
		<div>
			{ ! ShowHightLight ? (
				<button
					className="bg-green-600 px-2 py-2 rounded-md text-white"
					onClick={ () => updateShowHightLight( true ) }
				>
					Show HightLight
				</button>
			) : (
				<button
					className="bg-blue-600 px-2 py-2 rounded-md text-white"
					onClick={ () => updateShowHightLight( false ) }
				>
					Hide HightLight
				</button>
			) }
		</div>
	);
}

export default ShowHideHightLight;
